module.exports = __webpack_public_path__ + "img/Sycamore V1 960x540.3c7c479b.png";